export default __webpack_public_path__ + "static/tile-featured-b5d733dc67955ad6453dd731b3604379.jpg";